import { HttpResult } from 'widgets-for-react'
import { ActualityPageData } from '../../sharepointPageApi/types/pageData'

export const relatedDossierActualitiesBlockApi = async (
  dossierId: number
): Promise<HttpResult<ActualityPageData[]>> => {
  const res = await fetch(
    `/api/v1/pages/related-dossier-actualities?dossierId=${dossierId}`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: ActualityPageData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data
  }
}


export const relatedActualityActualitiesBlockApi = async (
  actualityId: number
): Promise<HttpResult<ActualityPageData[]>> => {
  const res = await fetch(
    `/api/v1/pages/related-actuality-actualities?actualityId=${actualityId}`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: ActualityPageData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data
  }
}
